<template>
  <div class="acomodar">
    <div class="mx-4 mt-4">
       <div class="bg-white rounded-3 p-4 mb-4 border shadow-sm">
      <div class="d-flex align-items-center mb-2">
        <i class="bi bi-filetype-exe text-success me-3 fs-1"></i>
        <div>
          <h4 class="fw-bold text-success mb-1">REPORTES</h4>
          <p class="fw-semibold text-secondary mb-0">DIFERENTES REPORTES DE SELECCION</p>
        </div>
      </div>
    </div>

    <div class="row g-3">
      <CardReporte 
        v-for="(reporte, index) in configReportes" 
        :key="index"
        v-bind="reporte"
      />
    </div>
    </div>
  </div>
</template>

<script>
import CardReporte from "@/components/CardReporte.vue";
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
  name: "SolimanologSeleccionReport",
  components: {
    CardReporte
  },
  data() {
    return {
      configReportes: [
        {
          titulo: "Reporte por Postulantes",
          descripcion: "Descarga la cantidad de postulantes seleccionados",
          endpoint: "ReportesExcel/ReporteSeleccion",
          fileName: "ReportePostulante.xlsx",
        },
        {
          titulo: "Reporte por Campaña",
          descripcion: "Descarga reporte por campañas",
          endpoint: "ReportesExcel/RepTiempoRq",
          fileName: "ReporteCampaña.xlsx",
        },
        {
          titulo: "Reporte por Documentos",
          descripcion: "Descarga el estado de documentos",
          endpoint: "ReportesExcel/ReportSelDocumentos",
          fileName: "ReporteDocumentos.xlsx",
          statusText: "Status",
        },
        {
          titulo: "Reporte de Tiempos",
          descripcion: "Descarga tiempos de selección",
          endpoint: "ReportesExcel/ReporteTiempoPostulante",
          fileName: "ReportTime.xlsx",
        },
         {
          titulo: "Reporte de Prueba",
          descripcion: "Descarga Pruebas",
          endpoint: "ReportesExcel/ReporteTiempoPostulante",
          fileName: "ReportPrueba.xlsx",
        }
      ]
    };
  },

  mounted() {
  },

  created() {
    this.cambiarEstadoNavbar();
  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    }
  },
};
</script>

<style scoped>

</style>
